var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.75C10.1989 6.75 10.3897 6.82902 10.5303 6.96967C10.671 7.11032 10.75 7.30109 10.75 7.5V11C10.75 11.1989 10.671 11.3897 10.5303 11.5303C10.3897 11.671 10.1989 11.75 10 11.75C9.80109 11.75 9.61032 11.671 9.46967 11.5303C9.32902 11.3897 9.25 11.1989 9.25 11V7.5C9.25 7.30109 9.32902 7.11032 9.46967 6.96967C9.61032 6.82902 9.80109 6.75 10 6.75Z",
    fill: "#E51C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5C11 13.7652 10.8946 14.0196 10.7071 14.2071C10.5196 14.3946 10.2652 14.5 10 14.5C9.73478 14.5 9.48043 14.3946 9.29289 14.2071C9.10536 14.0196 9 13.7652 9 13.5C9 13.2348 9.10536 12.9804 9.29289 12.7929C9.48043 12.6054 9.73478 12.5 10 12.5C10.2652 12.5 10.5196 12.6054 10.7071 12.7929C10.8946 12.9804 11 13.2348 11 13.5Z",
    fill: "#E51C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 3.5C8.95514 3.5 8.21614 4.202 7.84814 4.947C7.186 6.23255 6.51766 7.5149 5.84314 8.794L5.81514 8.846C5.13889 10.1277 4.46954 11.4131 3.80714 12.702C3.43514 13.454 3.32914 14.452 3.90014 15.316C4.47014 16.179 5.44214 16.5 6.36414 16.5H13.6361C14.5581 16.5 15.5311 16.18 16.1001 15.316C16.6701 14.452 16.5651 13.454 16.1931 12.702C15.9831 12.278 15.0801 10.555 14.1891 8.855L14.1571 8.794C13.4823 7.51505 12.814 6.2327 12.1521 4.947C11.7841 4.202 11.0451 3.5 10.0001 3.5ZM9.19214 5.612C9.59614 4.796 10.4041 4.796 10.8081 5.612C11.0101 6.021 11.9201 7.757 12.8301 9.492C13.5095 10.7801 14.1822 12.0718 14.8481 13.367C15.2521 14.184 14.8481 15 13.6361 15H6.36414C5.15214 15 4.74714 14.184 5.15214 13.367C5.35414 12.959 6.26514 11.22 7.17514 9.484C7.85415 8.19682 8.52649 6.90614 9.19214 5.612Z",
    fill: "#E51C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleIcon);
export default __webpack_public_path__ + "static/media/AlertTriangleIcon.fed963c95bb19215a3c9f9f876eb9a63.svg";
export { ForwardRef as ReactComponent };